export const AUTH_CONSTANTS = {
  // Left panel hero
  HERO: {
    COMPANY_ALT: 'Cantaloupe',
    BODY_TEXT:
      'A centralized hub for VDI integrations, device monitoring, and real-time operational insights.',
    ANIMATION_SEQUENCE: [
      'vending.',
      'micro markets.',
      'self-service.',
      'smart coolers.',
    ],
    COPYRIGHT_PREFIX: '© ',
    COPYRIGHT_SUFFIX: ' Cantaloupe, Inc.',
    COPYRIGHT_VERSION_SEPARATOR: ' · ',
  },

  // Feature chip labels
  FEATURES: {
    REALTIME_VDI: 'Near real-time VDI sync',
    WORKFLOW_TRACKING: 'Centralized request workflow tracking',
    SECURE_ACCESS: 'Secure role-based access',
    MULTI_OPERATOR: 'Multi-operator management',
    DEVICE_ALERTS: 'Real-time device alerts',
  },

  // Right panel card
  CARD: {
    WELCOME: 'Welcome',
    WELCOME_ACCENT: 'back',
    SUBTITLE: 'Sign in to your Gateway account',
    SIGN_IN_BUTTON: 'Sign in with Auth0',
    FOOTER_PREFIX: 'Secured by',
    FOOTER_BRAND: 'Auth0',
    FOOTER_SUFFIX: '',
  },
};
